export default {
    namespaced: true,
    state: {
        navBarSticky: false,
        showWelcomeBar: true
    },
    getters: {
        navBarSticky(state) {
            return state.navBarSticky;
        },
        showWelcomeBar(state) {
            return state.showWelcomeBar;
        }
    },
    actions: {

        setNaveBarSticky({ commit }, boolVal) {
            commit('setNaveBarSticky', boolVal);
        },
        setShowWelcomeBar({ commit }, boolVal) {
            commit('setShowWelcomeBar', boolVal);
        },

    },
    mutations: {
        setNaveBarSticky(state, boolVal) {
            state.navBarSticky = boolVal;
        },
        setShowWelcomeBar(state, boolVal) {
            state.showWelcomeBar = boolVal;
        },

    }
}












